import { createContext, useContext } from "react"

/**
 * Renders the combined receipt dialog for a connected jobs group.
 *
 * Injected via context so the shared UniversalJobCard never imports the CRM
 * api/query layer directly — that keeps the component renderable in Storybook
 * (and buildable by the docs project), where no renderer is provided and the
 * "Se gemensamt kvitto" menu item is simply hidden.
 */
export type GroupReceiptDialogRenderer = (props: {
  groupId: string
  onOpenChange: (open: boolean) => void
}) => React.ReactNode

const GroupReceiptDialogRendererContext =
  createContext<GroupReceiptDialogRenderer | null>(null)

export const GroupReceiptDialogRendererProvider =
  GroupReceiptDialogRendererContext.Provider

export function useGroupReceiptDialogRenderer(): GroupReceiptDialogRenderer | null {
  return useContext(GroupReceiptDialogRendererContext)
}
